/** @format */

export enum RecordStatus {
  NEW,
  EDITED,
  DELETED,
  SAVED,
  EDITING,
}
